(function(){
  function filename(src){
    try{
      var u = src || '';
      u = u.split('?')[0];
      u = u.substring(u.lastIndexOf('/') + 1);
      return (u || '').replace(/[-_]+/g,' ').replace(/\.[a-zA-Z0-9]+$/,'').trim();
    }catch(e){ return ''; }
  }
  function makeAlt(img){
    var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    var name = filename(src);
    var lower = (src + ' ' + name).toLowerCase();
    if (lower.indexOf('frame.svg') !== -1) return 'WonderBiotics newsletter subscribe button icon.';
    if (lower.indexOf('icon1.svg') !== -1 || lower.indexOf('icon2.svg') !== -1) return 'WonderBiotics partner brand logo icon.';
    if (lower.indexOf('weight') !== -1) return 'WonderBiotics probiotics for weight management product image.';
    if (lower.indexOf('gut') !== -1) return 'WonderBiotics probiotics for gut health product image.';
    if (lower.indexOf('vaginal') !== -1) return 'WonderBiotics probiotics for vaginal health product image.';
    if (name) return 'WonderBiotics ' + name + ' image.';
    return 'WonderBiotics wellness support image.';
  }
  function fix(node){
    var scope = node && node.querySelectorAll ? node : document;
    var imgs = scope.querySelectorAll('img');
    for (var i=0;i<imgs.length;i++){
      var img = imgs[i];
      var alt = img.getAttribute('alt');
      if (alt === null || String(alt).trim() === ''){
        img.setAttribute('alt', makeAlt(img));
      }
    }
  }
  function run(){ fix(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var mo = new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      for (var j=0;j<muts[i].addedNodes.length;j++){
        var n = muts[i].addedNodes[j];
        if (n && n.nodeType === 1) fix(n);
      }
    }
  });
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();
